import { omit } from "lodash";
import { modifyFilters } from "./FindingAPI";
import { makeCancellableAPIRequest } from "restAPI";

const InsightsStatsAPI = {
    getCWECVE(data = {}) {
        const {sortColumn, sortOrder} = data;
        data = {
            ...omit(data, ['sort', 'sortColumn', 'sortOrder']),
            ...( sortColumn && sortOrder ? {
                sortColumn,
                sortOrder
            } : {})
            // sort:  ? `${sortColumn},${sortOrder}` : undefined,
        }
        data = modifyFilters(data);
        return makeCancellableAPIRequest(
            "POST",
            `/api/insights/stats`,
            {
                data
            }
        )
    },
    getOWASP(data = {}) {
        data = modifyFilters(data);
        return makeCancellableAPIRequest(
            "POST",
            `/api/insights/owasp/stats`,
            {
                data
            }
        )
    },
    exportOWASPPDF(data  ={}) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/insights/owasp/stats/pdf`,
            {
                data,
                responseType: "arraybuffer",
            },
        )
    },
    // API will be working after deployment
    getByDeveloper(data = {}) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/insights/stats`,
            {
                data
            }
        )
    },
    getAI(data = {}){
        return makeCancellableAPIRequest(
            "POST",
            `/api/insights/aiinsight`,
            {
                data
            }
        )
    },
    getFilterValues(data = {}) {
        return makeCancellableAPIRequest(
            "POST",
            `/user/findings/insights/findings-filters`,
            {
                data
            }
        )
    },
    getASVS(data = {}){
        data = modifyFilters(data);
        return makeCancellableAPIRequest(
            "POST",
            `/api/insights/asvs/stats`,
            {
                data
            }
        )
    }
}

export default InsightsStatsAPI;